import { ConfigStore, connectionStore } from "../../../Common";
import { ConnectionNames } from "../../../Contracts";
import { connectWithSubscriptions } from "../ConnectWithSubscriptions";
export function connectSportsWithToken(token) {
    const sportConnection = connectionStore.get(ConnectionNames.sports);
    const sportConnectionConfig = ConfigStore.config.urls[ConnectionNames.sports];
    if (sportConnection && sportConnectionConfig) {
        sportConnection.updateToken(token);
        const url = {
            baseUrl: sportConnectionConfig.baseUrl,
            queryParams: Object.assign(Object.assign({}, sportConnectionConfig.queryParams), { jwt: ConfigStore.config.connections.jwt })
        };
        connectWithSubscriptions(sportConnection, url)
            .catch(console.error);
    }
    return token;
}
//# sourceMappingURL=connectSportsWithToken.js.map